/* Speedconsultants — course progress
   1. Records the last lesson opened.
   2. Fills the dashboard resume bar.
   3. Fills the homepage continue bar. */
(function () {
  var KEY = 'scs:last-lesson';

  /* ── 1. On a lesson page: remember it ───────────────────── */
  var head = document.querySelector('.scs-lesson-head .scs-lesson-title');
  if (head && document.querySelector('[data-scs-player], .scs-locked')) {
    try {
      localStorage.setItem(KEY, JSON.stringify({
        url: window.location.pathname,
        title: head.textContent.trim(),
        at: Date.now()
      }));
    } catch (e) {}
  }

  /* ── read it back once ──────────────────────────────────── */
  var last = null;
  try {
    var raw = localStorage.getItem(KEY);
    if (raw) last = JSON.parse(raw);
  } catch (e) {}
  if (!last || !last.url || !last.title) return;

  /* ── 2. Dashboard resume bar ────────────────────────────── */
  var box = document.getElementById('scs-resume');
  if (box) {
    var link = box.querySelector('a');
    var name = box.querySelector('.scs-resume-name');
    if (link && name) {
      link.setAttribute('href', last.url);
      name.textContent = last.title;
      box.hidden = false;
    }
  }

  /* ── 3. Homepage continue bar ───────────────────────────── */
  var bar = document.getElementById('scs-home-bar');
  if (bar) {
    var label = bar.querySelector('[data-scs-home-name]');
    if (label) {
      label.textContent = last.title;
      bar.setAttribute('href', last.url);
    }
  }
})();